import { useQueryClient } from '@tanstack/react-query';
import RequestDropdown from 'components/client-pool/RequestDropdown';
import usePropertyRequestsStore from 'store/propertyRequestsStore';

export default function NewRequestResults() {
    const { propertyRequestQueryFilter, page } = usePropertyRequestsStore();
    const data = useQueryClient().getQueryData(['getPropertyRequests', { ...propertyRequestQueryFilter, page: page + 1 }]) as Record<string, any>;
    return (
        <div className="flex items-center justify-between py-4 mt-7">
            <div className="flex items-center gap-2">
                <span className="text-lg font-poppins font-medium">Results</span>
                <span className=" bg-my-green  rounded-lg  px-2 py-0.5 text-base font-medium text-white">{data?.data?.data?.total}</span>
            </div>
            <div className="flex items-center gap-2 ">
                <RequestDropdown />
            </div>
        </div>
    );
}
